import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpRequest} from '@angular/common/http';
import { Observable } from "rxjs/Observable";

import {RestAbstractService} from "./abstract/rest.abstract.service";
import {environment} from "../../environments/environment";
import {AuthenticationService} from "./authentication.service";
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';

@Injectable()
export class RestService implements RestAbstractService {

    private readonly serverUrl: string;
    private readonly AUTH_TOKEN_HEADER: string = 'token';

    constructor(protected http: HttpClient, private authenticationService: AuthenticationService) {
        this.serverUrl = environment.apiV3Url;
    }

    private resolveUrl(path: string): string {
        return this.serverUrl + '/' + path;
    }

    private resolveHeaders(header: any): HttpHeaders {
        const headersConfig = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
        if(this.authenticationService.isAuthenticated){
            headersConfig['token'] =  this.authenticationService.token;

        }

        if (header) {
            //Object.keys(header).forEach((key) => {
            for(let key in header){
                headersConfig[key] = header[key].toString();
            };
        }
        return new HttpHeaders(headersConfig);
    }

    public delete(url: string, queryString?: string, body?: Object, header?: any): Observable<any> {
        return this.http.delete(
            this.resolveUrl(url),
            {headers: this.resolveHeaders(header)}
        ).pipe(
            map((res: HttpResponse<Response>) => res),
            catchError((res: Response) => this.handleError(res))
        )
    }

    public get(url: string, queryString?: string, body?: Object, header?: any): Observable<any> {
        return this.http.get(
            this.resolveUrl(url),
            {headers: this.resolveHeaders(header)}
        ).pipe(
            map((res: HttpResponse<Response>) => res),
            // catchError(this.handleError)
            catchError((res: Response) => this.handleError(res))
        )
            // .catch((error) => Observable.throw(error))
            // .map((res: HttpResponse<Response>) => res);
    }

    public post(url: string, queryString?: string, body?: Object, header?: any): Observable<any> {
        return this.http.post(
            this.resolveUrl(url),
            JSON.stringify(body),
            {headers: this.resolveHeaders(header)}
        ).pipe(
            map((res: HttpResponse<Response>) => res),
            // catchError((error) => Observable.throw(error))
            catchError((res: Response) => this.handleError(res))
            )
    }

    public put(url: string, queryString?: string, body?: Object, header?: any): Observable<any> {
        return this.http.put(
            this.resolveUrl(url),
            JSON.stringify(body),
            {headers: this.resolveHeaders(header)}
        ).pipe(
            map((res: HttpResponse<Response>) => res),
            // catchError((error) => Observable.throw(error))
            catchError((res: Response) => this.handleError(res))
        )
    }

    public download(url: string, type: string, queryString?: string, body?: Object, header?: any): Observable<any> {
        const req = new HttpRequest(
            'GET',
            this.resolveUrl(url),
            {
                headers: this.resolveHeaders(header),
                reportProgress: true,
                responseType: 'blob'}
        );
        return this.http.request(req)
            .catch((error) => Observable.throw(error));
    }

    private handleError(res: Response | any) {
        const statusCode = res.status;
        const error = {
            statusCode: statusCode,
            error: res.error
        };
        return throwError(error);
    }

    // public download(url: string, type: string, queryString?: any, data?: any, header?: any): Observable<any> {
    //     let options = this.createRequestOptions(queryString, header);
    //     options.responseType = ResponseContentType.Blob;
    //     let response = this.http.get(this.resolve(url), options);
    //
    //     response.subscribe(
    //         data => {
    //             let blob: any = new Blob([data.blob()], { type: type });
    //             window.open(window.URL.createObjectURL(blob));
    //         },
    //         error => console.log("Error downloading the file.", error),
    //     );
    //
    //     return response;
    // }

}
